'use client';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';
import { BaseLineCheckUnpick } from '@/app/components/icons/BaseLineCheckUnpick';
import { ProductLineElementLibrary } from '@/app/components/icons/ProductLineElementLibrary';
import { toast } from '@/app/components/ui/use-toast';
import { useTemplatesPanel } from './PanelContext';

export default function TemplateNotFound() {
  const t = useTranslations();
  useEffect(() => {
    toast({
      type: 'error',
      message: t('templates.notFound'),
    });
  }, [t]);

  const { setCollapsed } = useTemplatesPanel();

  return (
    <div className="-translate-x-1/2 pointer-events-auto absolute bottom-4 left-1/2 flex h-[68px] items-center gap-x-4 rounded-16 border border-system-white08 bg-[#1A1C20]/[.72] p-3 backdrop-blur-3xl sm:bottom-0 sm:h-fit sm:w-full sm:flex-col sm:rounded-b-none">
      <div className="group relative flex h-[96px] w-[72px] shrink-0 cursor-pointer items-end self-end rounded-12 border border-system-white16 bg-gradient-to-b from-[#162837] to-[#1B3247] backdrop-blur-3xl sm:hidden">
        <BaseLineCheckUnpick className="-translate-x-1/2 -translate-y-1/2 absolute top-1/2 left-1/2 text-2xl group-hover:hidden" />
        <div
          className="absolute inset-0 z-10 hidden flex-col items-center justify-center gap-2 rounded-12 bg-system-black36 group-hover:flex"
          onClick={() => {
            // 展开模板选择面板
            setCollapsed(false);
          }}
        >
          <ProductLineElementLibrary className="text-2xl text-system-white64" />
          <span className="text-xs">{t('templates.changeTemplate')}</span>
        </div>
      </div>
      <div className="min-w-[380px] pr-4 text-sm sm:min-w-[200px]">{t('templates.notFound')}</div>
    </div>
  );
}
